export const strings = {
  // Search
  searchStations: 'جستجوی ایستگاه‌ها',
  searchStationsOrCities: 'جستجوی ایستگاه یا شهر',
  noStationsFound: 'ایستگاهی یافت نشد',
  startTypingToSearch: 'برای جستجوی ایستگاه یا شهر شروع به تایپ کنید',
  clearSearch: 'پاک کردن جستجو',
  closeSearch: 'بستن جستجو',
  cancel: 'انصراف',
  searchStationsHint: 'برای جستجوی ایستگاه یا شهر، این قسمت را باز کنید',
  searchInputHint: 'نام ایستگاه یا شهر مورد نظر را تایپ کنید',

  // Location
  goToCurrentLocation: 'رفتن به موقعیت فعلی',

  // Station list (toggled on the map)
  stationsListTitle: 'فهرست ایستگاه‌ها',
  showStationsList: 'نمایش فهرست ایستگاه‌ها',
  hideStationsList: 'بستن فهرست ایستگاه‌ها',
  stationsListToggleHint: 'ایستگاه‌های نزدیک به مرکز نقشه را فهرست می‌کند',
  sortByLocationLabel: 'مرتب‌سازی بر اساس موقعیت من',
  sortByLocationHint: 'موقعیت شما دریافت و فهرست ایستگاه‌ها دوباره مرتب می‌شود',
  gettingLocation: 'در حال دریافت موقعیت',
  stationsSortedByLocation: 'فهرست بر اساس موقعیت شما مرتب شد',
  distanceFromMapCenter: 'فاصله',
  kilometersShort: 'کیلومتر',
  metersShort: 'متر',
  // Read out on each station list row, between the AQI and the distance.
  pollutants: 'آلاینده‌ها:',
  // Same as above: the action is announced as part of the row's label.
  doubleTapToShowOnMap: 'برای نمایش این ایستگاه روی نقشه، دو بار ضربه بزنید',

  // Metrics
  pm25: 'PM2.5',
  pm10: 'PM10',
  co: 'CO',
  no2: 'NO2',
  o3: 'O3',
  so2: 'SO2',

  // Metric change relative to the previous reading
  increased: 'افزایش',
  decreased: 'کاهش',
  unchanged: 'بدون تغییر',

  // Screen titles & navigation
  mapLabel: 'نقشه',
  newsLabel: 'اخبار',
  guidesLabel: 'راهنما',
  openMap: 'رفتن به نقشه',
  openNews: 'رفتن به اخبار',
  openGuides: 'رفتن به راهنما',

  // Page <title> / meta description (used by the web build, see
  // src/utils/pageMeta.web.ts; keep in sync with web/index.html)
  pageMeta: {
    map: {
      title: 'کیفیت هوا | نقشه لحظه‌ای کیفیت هوای ایران',
      description:
        'شاخص لحظه‌ای کیفیت هوا (AQI) شهرهای ایران روی نقشه؛ وضعیت PM2.5، PM10، CO، NO2، O3 و SO2 در ایستگاه‌های پایش هوا.',
    },
    news: {
      title: 'اخبار آلودگی هوا | کیفیت هوا',
      description:
        'آخرین اخبار و گزارش‌ها درباره آلودگی هوا و کیفیت هوای شهرهای ایران.',
    },
    guides: {
      title: 'راهنمای کیفیت هوا و شاخص AQI | کیفیت هوا',
      description:
        'راهنمای شاخص کیفیت هوا (AQI)، آلاینده‌ها و ذرات معلق؛ آموزش خواندن وضعیت هوا و راهکارهای کاهش اثر آلودگی هوا.',
    },
  },

  // Accessibility labels & hints (announced by screen readers)
  stationMarkerHint: 'برای مشاهده جزئیات ایستگاه، ضربه بزنید',
  airQualityIndex: 'شاخص کیفیت هوا',
  opensInBrowser: 'در مرورگر باز می‌شود',
  loading: 'در حال بارگذاری',

  // Errors
  unableToLoadStations: 'امکان بارگذاری ایستگاه‌ها وجود ندارد',
  unableToLoadAffiliation: 'امکان بارگذاری اطلاعات وجود ندارد',
  unableToLoadNews: 'امکان بارگذاری اخبار وجود ندارد',
  unableToLoadGuide: 'امکان بارگذاری راهنماها وجود ندارد',
  unableToDetermineLocation: 'امکان تعیین موقعیت شما وجود ندارد',
} as const;
